import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, getApi } from 'services/rotasp/api';
import { PATH_PPT_POUPA_FILA } from 'services/rotasp/path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { RecuperarAtendimentoIntegradorPPTRequest, Types } from './types';

// ACTIONS
import {
	recuperarAtendimentoIntegradorPPTSuccess,
	recuperarAtendimentoIntegradorPPTFailure,
} from './actions';

function* recuperarAtendimentoIntegradorPPTRequest(request: ReducerAction) {
	const {
		token,
		payload,
	}: { payload: RecuperarAtendimentoIntegradorPPTRequest; token?: string } =
		request;

	const response: ApiResponse = yield call(
		getApi,
		token || '',
		PATH_PPT_POUPA_FILA,
		`atendimentos?cpfAtendente=${payload.cpf}`,
	);

	if (response.status === 200) {
		yield put(recuperarAtendimentoIntegradorPPTSuccess(response.data));
	} else {
		yield put(recuperarAtendimentoIntegradorPPTFailure(response));
	}
}

export default all([
	takeLatest(
		Types.RECUPERAR_ATENDIMENTO_INTEGRADOR_PPT_REQUEST,
		recuperarAtendimentoIntegradorPPTRequest,
	),
]);
